      
<template>
    <div >
        <div class="container">
            <div class="contentTop"></div>
            <div class="center">
                <div class="userBox">
                    <img class="avatar" :src="info.avatar" alt="">
                    <p class="userName">
                        {{info.user_nickname}}<span v-if="!info.name ? false : true" style="color:#999999">({{info.name}})</span>
                    </p>
                    <p class="subTitle" > 
                        <!-- <span class="lightGray" v-if="!info.remark ? false :true">“ </span>{{info.remark}}<span class="lightGray"> ”</span> -->
                        <span class="lightGray" v-if="!info.remark ? false :true">
                            “ <span class="subTitleText"> {{info.remark}} </span> ”
                        </span>
                    </p>
                </div>
                <div class="bottom">
                    <div v-for="(item,index) of list" :key="index">
                        <van-cell is-link :title="item.title" :value="index==0 ? info.order_num : ''" @click="handleClick(index)">
                            <template #icon>
                                <img class="icon"  :src="item.icon" alt="">
                            </template>
                        </van-cell>
                    <van-divider style="background:rgba(241,241,241,1);margin:0 15px" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tabbar from "@/components/agentTabbar"
import { Dialog,Toast } from 'vant';
export default {
    data() {
        return {
            list:[{id:"1",title:"保险订单",icon:require("../../assets/icons/baoxian.png")},
                  {id:"2",title:"设置备注",icon:require("../../assets/icons/xubao.png")},
                  {id:"3",title:"联系客户",icon:require("../../assets/icons/tuibao.png")},
            ],
        };
    },
    created(){
        document.title=this.info.user_nickname;
      
    },
    methods: {
        handleClick(e){
            if(e==0){
                this.$router.push({path:"/myOrder/0",query:{"uid":this.info.id}})
            }else if(e==1){
                this.$router.push({path:"/noteInfo"})
            }else{
                if(!this.info.tel){
                    console.log("tel是空号码");
                    Toast("请在设置备注里填写客户号码")
                }else{
                    window.location.href="tel://"+this.info.tel;
                }
            }
        },
        //获取会员备注信息
        // getClienInfo(){
        //      this.$https.fetchPost("user/getUserRemark",{"id":this.id})
        //     .then(result=>{
        //         let data=result.data;
        //         //手机为空的话，弹出绑定手机页面，进行手机绑定
        //         if(data.code==1){
        //             let tel=data.data.tel;
        //             if(tel==""){
        //                 Toast("没有客户电话")
        //             }else{
        //                 window.location.href=tel;
        //             }
        //         }else{
        //             Toast(data.msg)
        //         }
        //     })
        // },
    },
    components:{
        tabbar,
        [Dialog.Component.name]: Dialog.Component,
    },
    computed:{
        info:{
            get(){
                return this.$store.state.clientInfo;
            },
            set(newValue){
                return newValue
            }
        }
    },
}
</script>

<style scoped>
    .contentTop{
        /* position: relative; */
        width: 100%;
        height: 140px;
        background:linear-gradient(302deg,rgba(243,71,64,1),rgba(254,142,137,1));
    }
    .center{
        text-align: start;
        color: #666666;
        /* border-radius:10px 10px 0px 0px; */
        /* background:rgba(255,255,255,1); */
        margin-top: -70px;
        margin-left: 12px;
        margin-right: 12px;
        border-radius:6px;
    }
    .userBox{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.06);
        border-radius:7px;
    }
    .avatar{
        width: 85px;
        height: 85px;
        border-radius: 50%;
        margin-top: -28px;
    }
    .userName{
        color: #313131;
        font-size: 17px;
        margin: 14px;
    }
    .subTitle{
        margin: 0;
        margin-bottom: 30px;
    }
    .lightGray{
        font-size: 20px;
        color:rgba(240,240,240,1);
    }
    .subTitleText{
         color: #666666;
         font-size: 12px;
    }
    .bottom{
        margin-top:20px;
        background: #fff;
        box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.06);
        border-radius:7px;
    }
    .van-cell{
        color: #666;
        font-size: 13px;
        padding:12px 10px;
        align-items: center;
        background: transparent;
    }
    .icon{
        width: 18px;
        height: 19px;
        margin-right: 15px;
    }
    .van-cell__value{
        color: rgba(243,71,64,1);
    }
   
</style>


// WEBPACK FOOTER //
// src/views/agentMy/clientInfo.vue